import {
  createSurgardIntegrationAsync,
  deleteSurgardIntegrationAsync,
  getAllSurgardIntegrationAsync,
  getSurgardIntegrationByIdAsync,
  updateSurgardIntegrationAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateSurgardIntegrationAsync = () =>
  useMutation(createSurgardIntegrationAsync);

export const useGetSurgardIntegrationByIdAsync = () =>
  useMutation(getSurgardIntegrationByIdAsync);

export const useGetAllSurgardIntegrationAsync = () =>
  useMutation(getAllSurgardIntegrationAsync);

export const useUpdateSurgardIntegrationAsync = () =>
  useMutation(updateSurgardIntegrationAsync);

export const useDeleteSurgardIntegrationAsync = () =>
  useMutation(deleteSurgardIntegrationAsync);
